import React, { useState } from 'react';
import { useMutation } from 'react-query';
import SVG from 'react-inlinesvg';
import ChevronRightIcon from '../../../../../../../../assets/images/reskin-images/icon--chevrons-right.svg';
import { adminAPI } from '../../../../../api';
import FormLoader from '../../../../../components/FormLoader';
import useAlarm from '../../../../../context/AlarmContext';
import CellInput from '../../../../../components/forms/inputTypes/CellInput';

const AddRepresentative = ({ id, setOpenSideActionBoard, onSuccess }) => {
  const [formData, setFormData] = useState({
    userEmails: [],
  });
  const { setAlarm } = useAlarm();

  const handleUserEmailsChange = (emails) => {
    setFormData((prevData) => ({
      ...prevData,
      userEmails: [...emails],
    }));
  };

  const { mutate: addRepresentativeMutation, isLoading: updateLoading } =
    useMutation(adminAPI.addRepresentativesToCohort, {
      onSuccess: (data) => {
        setOpenSideActionBoard();
        setAlarm({
          type: 'success',
          message: data?.message || 'Representatives added successfully',
        });
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error) => {
        setOpenSideActionBoard();
        setAlarm({ type: 'error', message: error.message });
      },
    });

  const handleSubmit = (e) => {
    e.preventDefault();
    addRepresentativeMutation({ id, cohort: formData });
  };

  return (
    <>
      <div className="flex justify-between items-center relative pb-4 px-8">
        <button
          className="p-2 flex items-center -ml-2"
          type="button"
          onClick={() => setOpenSideActionBoard()}
        >
          <SVG src={ChevronRightIcon} />
        </button>
        <span
          style={{ width: 'calc(100% + 6rem)' }}
          className="absolute pin-b pin-r -mx-16 h-px bg-gray flex"
        />
      </div>

      <form
        className="overflow-y-scroll h-full px-8 py-8"
        onSubmit={handleSubmit}
      >
        <h1>Add Representative</h1>

        <div style={{ gap: '16px' }} className="flex flex-col my-12">
          <CellInput
            title="Representative Emails"
            type="email"
            onChangeCells={(cells) => handleUserEmailsChange(cells)}
            defaultCells={formData.userEmails}
            checkUserEmail={true}
          />
        </div>

        <button
          className="mb-20 p-4 bg-purple-500 text-white font-semibold rounded-lg hover:bg-purple-700 transition-colors"
          type="submit"
          disabled={!formData.userEmails.length}
        >
          Add
        </button>

        {updateLoading && <FormLoader />}
      </form>
    </>
  );
};

export default AddRepresentative;